import React, { useEffect, useState } from 'react'
import { send_demand } from '../../../commons/api'
import { Button, useToast } from '@chakra-ui/react'
import './style.css'
import { useDispatch } from 'react-redux'
import { UPDATE_PROFILE } from '../../../commons/redux/constants'
export default function Demand() {
  const [load, setLoad] = useState(false)
  const dispatch = useDispatch()
  const toast = useToast()
  const token = localStorage.getItem('token')

  const [command, setCommand] = useState({
    kind: '',
    price: '',
    time: '',
    date: '',
    desc: '',
  })

  const handle = (e) => {
    const { name, value } = e.target
    setCommand({ ...command, [name]: value })
    console.log(value);
  }
  const send = async () => {
    setLoad(true)
    try {
      const { user, create, statusCode } = await send_demand(command)
      if (create) {
        toast({
          title: 'Demande envoye',
          description: 'Felicitation votre commande a ete prise en compte',
          status: 'success',
          position: 'bottom',
          duration: 9000,
          isClosable: true,
        })
      }

      dispatch({
        type: UPDATE_PROFILE,
        payload: user,
      })
      if (statusCode === 400) {
        toast({
          title: 'Champs manquants',
          description: 'Veuillez remplir tous les champs',
          status: 'error',
          position: 'bottom',
          duration: 9000,
          isClosable: true,
        })
      }
      setLoad(false)
    } catch (error) {
      setLoad(false)
      console.log('error')
    }
  }

  useEffect(() => {
    if (typeof window != 'undefined' && !token) {
      window.location.href = '/se-connecter'
    }
  }, [token])
  return (
    <>
      <div className="container-fluid">
        <div className="container row lg:p-4  lg:m-0">
          <div className="mx-auto text-left mt-2 col-lg-4  ">
            <div className="text-xl head text-center font-bold title_demand ">
              <h2>Commandez un service rapidement !</h2>
            </div>
            <form className="form_command">
              <hr className="text-gray  text-center mx-auto" />
              <legend className="mb-0 mt-2">La Commande</legend>
              <div className="form-group">
                <label
                  htmlFor="kind"
                  className="sr-onl block text-gray-700 text-sm font-bold mt-1"
                >
                  Travailleur
                </label>{' '}
                <select
                  name="kind"
                  onChange={handle}
                  className="appearance-none form-select border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                  id=""
                >
                  <option value="baby sitter">Baby-Sitter</option>
                  <option value="plombier">Plombier</option>
                  <option value="electricien">Electricien</option>
                  <option value="macon">Macon</option>
                  <option value="peintre">Peintre</option>
                  <option value="depanneur de telephone">
                    Depanneur telephone
                  </option>
                  <option value="depanneur d'ordinateur">
                    Depanneur ordinateur
                  </option>
                  <option value="frigoriste">Frigoriste</option>
                  <option value="menuisier">Menuisier</option>
                  <option value="cuisinier">Cuisinier</option>
                  <option value="cuisinier">Masseur</option>
                  <option value="major d'homme">Majord'Homme</option>
                  <option value="menagere">Menagere</option>
                  <option value="lessiveuse">Lessiveuse</option>
                  <option value="tache generique">Tache generique</option>
                  <option value="autre">Autre...</option>
                </select>
              </div>

              <div>
                <label
                  htmlFor=""
                  className="sr-onl block text-gray-700 text-sm font-bold mt-1"
                >
                  Budget
                </label>{' '}
                <input
                  type="number"
                  name="price"
                  onChange={handle}
                  className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                />
              </div>

              <legend className="mb-0 mt-2">Preference</legend>

              <div>
                <label
                  htmlFor=""
                  className="sr-onl block text-gray-700 text-sm font-bold mt-1"
                >
                  Langue{' '}
                </label>{' '}
                <select
                  name="language"
                  id="lng"
                  className="appearance-none form-input form-select  border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                  onChange={handle}
                >
                  <option value="francais">Francais</option>
                  <option value="Wolof">Wolof</option>
                  <option value="English">Anglais</option>
                  <option value="Haoussa">Haoussa</option>
                  <option value="Arabe">Arabe</option>
                  <option value="autre">Autre</option>
                </select>
              </div>

              <legend className="mb-0 mt-2">Moment</legend>
              <div>
                <label
                  htmlFor=""
                  className="sr-onl block text-gray-700 text-sm font-bold mt-1"
                >
                  Date
                </label>{' '}
                <input
                  type="date"
                  name="date"
                  onChange={handle}
                  className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                />
              </div>
              <div>
                <label
                  htmlFor=""
                  className="sr-onl block text-gray-700 text-sm font-bold mt-1"
                >
                  Heure
                </label>{' '}
                <input
                  type="time"
                  name="time"
                  onChange={handle}
                  className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                />
              </div>

              <div className="form-group">
                <label
                  htmlFor=""
                  className="sr-onl block text-gray-700 text-sm font-bold mt-1"
                >
                  Decrire la tache
                </label>{' '}
                <textarea
                  placeholder="Expliquez le travail a faire..."
                  name="desc"
                  onChange={handle}
                  className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                  id=""
                  cols="30"
                  rows="2"
                ></textarea>
              </div>
              <div className="my-2">
                {load ? (
                  <Button
                    isLoading
                    loadingText="Publication..."
                    colorScheme="red"
                    width="100%"
                    variant="outline"
                  >
                    Patientez...
                  </Button>
                ) : (
                  <Button
                    variant={'outline'}
                    className="btn-block"
                    width="100%"
                    onClick={send}
                    colorScheme="red"
                  >
                    Envoyer
                  </Button>
                )}{' '}
              </div>
            </form>
          </div>
          <div className="col-lg-6 mt-3 d-block d-none d-lg-block">
            <img
              src="./images/olga.jpg"
              alt="tools"
              className="w-full h-75 object-cover"
            />
          </div>
        </div>
      </div>
    </>
  )
}
